import API from './index';

const api = {
    getReviewerList({ params }) {
        return API.authAPI({
            url: '/user/get-reviewer-byParams',
            method: 'GET',
            params: { ...params },
        });
    },
    addReviewerAccount(data) {
        return API.authAPI({
            url: '/user/add-reviewer-account',
            method: 'POST',
            data,
        });
    },
    updateReviewerAccount(data) {
        return API.authAPI({
            url: '/user/reviewer-edit',
            method: 'POST',
            data,
        });
    },
    getReviewerDetail(email) {
        return API.authAPI({
            url: '/user/reviewer-detail',
            method: 'GET',
            params: { email: email },
        });
    },
    deleteReviewerAccount(data) {
        return API.authAPI({
            url: '/user/delete-reviewer-account',
            method: 'POST',
            data,
        });
    },
    updateReviewerPassword(data) {
        return API.authAPI({
            url: '/user/update-reviewer-password',
            method: 'POST',
            data,
        });
    },
    getReviewerComment(data) {
        return API.authAPI({
            url: '/arrangement-meeting/get-reviewer-comment-byParams',
            method: 'GET',
            params: { ...data },
        });
    },
};

export default api;
